// extracted by mini-css-extract-plugin
export default {"dottedBox":"styles_dottedBox__gAl8j"};